<template>
  <div id="SovecoNavBar">
    <nav class="navbar is-dark" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <img src="images/logo-soveco-navbar.png" />
      </div>
      <div class="navbar-menu">
        <div class="navbar-start">
          <router-link to="Map" class="navbar-item">
            <div class="has-text-centered nav-item">
              <figure class="figure-nav image is-16x16">
                <img src="images/earth-globe.png" />
              </figure>
              Mappa
            </div>
          </router-link>
          <router-link to="List" class="navbar-item">
            <div class="has-text-centered nav-item">
              <figure class="figure-nav image is-16x16">
                <img src="images/list.png" />
              </figure>
              Lista
            </div>
          </router-link>

          <template v-if="isFull">
            <router-link to="Drivers" class="navbar-item">
              <div class="has-text-centered nav-item">
                <figure class="figure-nav image is-16x16">
                  <img src="images/delivery-man.png" />
                </figure>
                Autisti
              </div>
            </router-link>
          </template>

          <router-link to="Vehicles" class="navbar-item">
            <div class="has-text-centered nav-item">
              <figure class="figure-nav image is-16x16">
                <img src="images/truck.png" />
              </figure>
              Mezzi
            </div>
          </router-link>

          <template v-if="isFull">
            <router-link to="Graphs" class="navbar-item">
              <div class="has-text-centered nav-item">
                <figure class="figure-nav image is-16x16">
                  <img src="images/bar-chart.png" />
                </figure>
                Grafici
              </div>
            </router-link>
          </template>

          <router-link to="Reports" class="navbar-item">
            <div class="has-text-centered nav-item">
              <figure class="figure-nav image is-16x16">
                <img src="images/file.png" />
              </figure>
              Reports
            </div>
          </router-link>

          <template v-if="isFull">
            <router-link to="pois" class="navbar-item">
              <div class="has-text-centered nav-item">
                <figure class="figure-nav image is-16x16">
                  <img src="images/placeholder.png" />
                </figure>
                POI
              </div>
            </router-link>
            <router-link to="kft" class="navbar-item">
              <div class="has-text-centered nav-item">
                <figure class="image is-16x16">
                  <img src="images/kft.png" />
                </figure>
                Cronotachigrafo
              </div>
            </router-link>
            <router-link to="fms" class="navbar-item">
              <div class="has-text-centered nav-item">
                <figure class="image is-16x16">
                  <img src="images/fms.png" />
                </figure>
                FMS
              </div>
            </router-link>
            <router-link to="settings" class="navbar-item">
              <div class="has-text-centered nav-item">
                <figure class="image is-16x16">
                  <img src="images/preference.png" />
                </figure>
                Preferenze
              </div>
            </router-link>
            <template v-if="auth.flag_actia">
              <router-link to="actia" class="navbar-item">
                <div class="has-text-centered nav-item">
                  <figure class="image is-16x16">
                    <img src="images/actia.png" />
                  </figure>
                  Actia
                </div>
              </router-link>
            </template>
            <router-link to="androidapp" class="navbar-item">
              <div class="has-text-centered nav-item">
                <figure class="image is-16x16">
                  <img src="images/android.png" />
                </figure>
                App Android
              </div>
            </router-link>
          </template>
          <div></div>
        </div>
      </div>
      <div class="is-vertical-center is-right-padding">
        <div class="pr-1">{{ nome }}&nbsp; &nbsp;({{ serverName }})</div>
        <span class="button is-danger is-small" @click="logout">LogOut</span>
      </div>
    </nav>
  </div>
</template>
<script>
import { ServiceBus } from '../../ServiceBus.js'
import axios from 'axios'
import { UtilityMixin } from '../../mixins/UtilityMixin.js'
export default {
  name: 'SovecoNavBar',
  mixins: [UtilityMixin],

  data() {
    return {
      api_server: '',
      nome: '',
      isFull: false,
      prefs: null,
      auth: null,
      serverName: '',
    }
  },
  mounted() {
    const vm = this
    vm.api_server = vm.getApiServer()
    vm.serverName = vm.getServerName()
    vm.isFull = vm.auth.tipo !== 3
    if (vm.isFull) {
      vm.nome = vm.auth.nome
    } else {
      vm.nome =
        vm.auth.nome + ' ' + vm.auth.login_base + '-' + vm.auth.login_tmp + ' '
    }
  },
  created() {
    const vm = this
    vm.prefs = JSON.parse(vm.$localStorage.get('prefs'))
    vm.auth = JSON.parse(vm.$localStorage.get('auth'))
  },
  methods: {
    handler() {
      this.do_log()
      this.do_user_status()
    },
    async logout() {
      const vm = this
      await vm.do_log()
      await vm.do_user_status()
      vm.$router.push({ path: '/login' })
    },
    async do_log() {
      const vm = this
      let data = {
        cod: vm.auth.cod,
        state: 0,
        date: new Date().toLocaleMysqlString(),
      }
      return axios.post(vm.api_server + 'insert_logs', data, {
        headers: {
          Authorization: vm.auth.tkn,
        },
      })
    },
    async do_user_status() {
      const vm = this
      let data = {
        cod: vm.auth.cod,
        state: 0,
        date: new Date().toLocaleMysqlString(),
      }
      return axios.post(vm.api_server + 'update_user_status', data, {
        headers: {
          Authorization: vm.auth.tkn,
        },
      })
    },
  },
}
</script>
